import { configureStore } from "@reduxjs/toolkit";
import architaMotorsSilceOne from "../redux/Slice/architaMotorsSilceOne";

export const store = configureStore({
  reducer: {
    architaMotors: architaMotorsSilceOne,
  },
});
